module.exports = __webpack_public_path__ + "static/media/stryqer-logo.ee2ee1ef.svg";